import type { StoryElement } from '../types';
import { storyPermalinkUrl } from '../utils/storyPermalink';
import { CopyLinkControl } from './CopyLinkControl';
import { IconLink } from './icons';
import { readerEvent } from '../utils/readerTelemetry';

export function StoryPermalinkButton({
  story,
  surface,
}: {
  story: Pick<StoryElement, 'id' | 'topic_id'>;
  /** Set on reader surfaces, which record the copy. */
  surface?: string;
}) {
  return (
    <CopyLinkControl
      getUrl={() => storyPermalinkUrl(story)}
      title="Copy story link"
      ariaLabel="Copy story link"
      copiedMessage="Story link copied"
      errorMessage="Could not copy story link"
      onCopied={surface ? () => readerEvent('story_link_copy', { story_id: story.id, method: 'button', surface }) : undefined}
    >
      <IconLink />
    </CopyLinkControl>
  );
}
